<template>
  <v-container class="testimonial-section-wrapper" fluid>
    <v-row>
      <v-col class="col-12 text-wrapper">
        <h2 v-html="data.title"></h2>
      </v-col>
    </v-row>
    <v-row class="testimonials-wrapper">
      <v-col class="col-12">
        <VueSlickCarousel v-bind="settings">
          <template v-for="(testimonial, i) in data.testimonials">
            <v-row :key="i" class="fill-height">
              <v-col class="col-12">
                <div class="testimonial-container">
                  <div class="header">
                    <v-avatar size="93">
                      <img :src="testimonial.photo" :alt="testimonial.name" />
                    </v-avatar>
                    <div class="text-wrapper">
                      <h3>{{ testimonial.name }}</h3>
                      <h4>{{ testimonial.role }}</h4>
                    </div>
                  </div>
                  <div class="content">
                    <p v-html="testimonial.text"></p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </template>
        </VueSlickCarousel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'TestimonialSectionBusinesses',
  components: {
    VueSlickCarousel,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      settings: {
        centerMode: true,
        centerPadding: '100px',
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 1,
        speed: 500,
        arrows: false,
        dots: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              centerPadding: '20px',
              swipe: true,
              adaptiveHeight: true,
            },
          },
        ],
      },
    };
  },
  beforeMount() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.testimonial-section-wrapper
  padding: 0 12px 150px
  .text-wrapper
    justify-content: center
    align-items: center
    display: flex
    flex-flow: column
    h2
      display: inline-block
      font-family: 'metropolissemi_bold'
      font-style: normal
      font-weight: 600
      font-size: 32px
      color: #003036
      line-height: 1
      padding-bottom: 5px
      border-bottom: 4px solid #26D07C
      margin-bottom: 50px
  .testimonials-wrapper
    ::v-deep
      .slick-list
        max-height: 410px
      .slick-slide
        max-width: 980px
        &.slick-active
          .testimonial-container
            background: #EEFBF5
            transition: all 300ms ease-in-out
        .row
          .col
            padding: 0 20px
        .testimonial-container
          background: #F2F2F3
          min-height: 410px
          padding: 65px 70px 100px
          backdrop-filter: blur(5px)
          transition: all 300ms ease-in-out
          .header
            display: flex
            justify-content: flex-start
            align-items: center
            margin-bottom: 50px
            .v-avatar
              margin-right: 40px
            .text-wrapper
              display: block
              h3,
              h4
                font-style: normal
                line-height: 1
                margin: 0
                padding: 0
              h3
                font-family: 'metropolissemi_bold'
                font-weight: 600
                font-size: 24px
                color: #003036
                margin-bottom: 10px
              h4
                font-family: 'metropolisregular'
                font-weight: 400
                font-size: 18px
                color: #72737A
          .content
            p
              display: inline-block
              font-family: 'metropolisregular'
              font-style: normal
              font-weight: 400
              font-size: 18px
              line-height: 1.4
              color: #003036
              margin: 0
              &:before,
              &:after
                display: inline-block
                content: '"'
                font-family: 'metropolisbold'
                font-weight: 700
              &:before
                margin-right: 5px
              &:after
                margin-left: 5px
              span
                font-family: 'metropolisbold'
                font-style: normal
                font-weight: 700
      .slick-dots
        padding: 0 !important
        bottom: -50px
        li
          width: 23px
          height: 23px
          margin: 0 10px
          transition: all 300ms ease-in-out
          &.slick-active
            transition: all 300ms ease-in-out
            button
              width: 23px
              height: 23px
              &:before
                background: #ffffff
                border: 6px solid #26D07C
                width: 23px
                height: 23px
                color: transparent
                border-radius: 50px
                line-height: 1
                top: 0
                left: 0
                transition: all 300ms ease-in-out
          button
            width: 23px
            height: 23px
            padding: 0
            &:before
              background: #003036
              width: 16px
              height: 16px
              color: transparent
              border-radius: 50px
              line-height: 1
              opacity: 1
              top: 3px
              left: 3px
              transition: all 300ms ease-in-out
    @media screen and (max-width: 959px)
      ::v-deep
        .slick-list
          max-height: 100%
          padding: 0 12px !important
          .row
            .col
              padding: 0 12px
        .slick-slide
          max-width: 911px
          .testimonial-container
            min-height: auto
            padding: 20px
            .header
              display: block
              .v-avatar
                width: 100% !important
                margin-right: 0
                margin-bottom: 30px
                img
                  max-width: 93px
    @media screen and (max-width: 768px)
      ::v-deep
        .slick-slide
          max-width: 720px
    @media screen and (max-width: 500px)
      ::v-deep
        .slick-slide
          max-width: 452px
    @media screen and (max-width: 425px)
      ::v-deep
        .slick-slide
          max-width: 377px
    @media screen and (max-width: 414px)
      ::v-deep
        .slick-slide
          max-width: 366px
    @media screen and (max-width: 412px)
      ::v-deep
        .slick-slide
          max-width: 364px
    @media screen and (max-width: 390px)
      ::v-deep
        .slick-slide
          max-width: 342px
    @media screen and (max-width: 375px)
      ::v-deep
        .slick-slide
          max-width: 327px
    @media screen and (max-width: 320px)
      ::v-deep
        .slick-slide
          max-width: 272px
</style>
